import { customUrlActions } from '../actions';

export default function customUrl ( initialState = {}, action ) {
    const newState = { ...initialState };

    switch ( action.type ) {
        case customUrlActions.SET_CUSTOM_URL: return generalCustomUrlReducer( newState, action );
        default: return newState;
    }
}

function generalCustomUrlReducer ( newState, action ) {
    delete action.type;
    return Object.assign( newState, { ...action } );
}


// WEBPACK FOOTER //
// src/client/components/site/features/profile/reducers/url.js